import { Identified } from "@/types/sdk-types";
import { GridSortModel } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../../../hooks/use-encounter-creation-gate";
import {
  PrescriptionForm,
  PrescriptionFormControllerApi,
} from "../../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  patientUuid?: string;
  appointmentUuid?: string;
  active?: boolean;
  archive?: boolean;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetOrderPrescription = ({
  pagination,
  gridSorting,
  patientUuid,
  appointmentUuid,
  active,
  archive,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<Identified<PrescriptionForm>> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  const skip = useEncounterCreationGate();
  return useQuery({
    queryKey: [
      "patient-prescription-list",
      pagination,
      gridSorting,
      patientUuid,
      pageIndex,
      appointmentUuid,
      active,
      archive,
      xTENANTID,
    ],
    enabled: !skip && enabled,
    refetchOnWindowFocus: false,

    queryFn: async () =>
      await new PrescriptionFormControllerApi(getConfigObject())
        .getPrescriptionForms(
          pagination.page,
          pagination.pageSize,
          sortBy,
          sortDirect,
          patientUuid,
          appointmentUuid,
          active,
          archive,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
